import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom';
import tickImg from './../../../assets/tick.svg';
import closeImg from './../../../assets/cross.svg';

const SuccessAlert = ({ children, disappearTime, onDisappear }) => {
  const [showElement, setShowElement] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowElement(false);
      onDisappear && onDisappear();
    }, disappearTime);

    return () => clearTimeout(timer);
  }, [disappearTime, onDisappear]);

  return (
    createPortal(
        <>
          { showElement && <div className="p-2 text-sm text-white rounded-lg flex justify-center items-center bg-success-2 fixed top-[74px] left-0 right-0 m-auto text-center z-[99] max-w-[380px]">
            <img src={tickImg} alt="tick" className="w-6 h-6 inline-block mr-1" /> { children }
            <button className="w-4 h-4 inline-block absolute right-3 top-3" onClick={() => {
              setShowElement(false);
              onDisappear && onDisappear();
            }}><img src={closeImg} alt="" /></button>
          </div> }
        </>,
        document.getElementById('alert')
    )
  )
}

export default SuccessAlert;